import React from "react";
import { Navigate, useLocation } from "react-router-dom";

/**
 * Phase 35 — the `local` storefront was removed from the UI. Any residual
 * `/local/*` URL (bookmarks, cached links, admin dashboards that still
 * hardcoded the prefix) is 301-style redirected to the equivalent
 * `/envio/*` path so nothing 404s.
 *
 * Preserves the query string and any trailing subpath. Both catalog
 * navigation (`/local/categoria/…`) and product detail
 * (`/local/producto/…`) fall through here automatically because we mount
 * the component under `<Route path="/local/*" …>`.
 */
export default function LocalToEnvioRedirect() {
  const { pathname, search, hash } = useLocation();
  const rewritten =
    (pathname.startsWith("/local")
      ? "/envio" + pathname.slice("/local".length)
      : "/envio/") + (search || "") + (hash || "");
  return <Navigate to={rewritten} replace />;
}
